var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadDone = function SvgDownloadDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "download_done_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#download_done_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 13.15 18 4.7q.3-.3.712-.3.413 0 .713.3t.3.713-.3.712L10.25 15.3q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-4.275-4.275a.93.93 0 0 1-.288-.713A1.02 1.02 0 0 1 4.6 9.6q.3-.3.712-.3.413 0 .713.3zM6 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 19q0-.424.287-.712A.97.97 0 0 1 6 18h12q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 18 20z"
  }))));
};
export default SvgDownloadDone;